import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  ViewEncapsulation,
  HostBinding,
} from '@angular/core';
import { formatLabel } from '../label.helper';
import { ColorHelper } from '../color.helper';

export interface LegendEntry {
  color: string;
  formattedLabel: string;
  label: string;
}

@Component({
  selector: 'ngx-charts-legend',
  template: `
    <div [style.width.px]="lwidth">
      <header class="legend-title" *ngIf="title?.length > 0">
        <span class="legend-title-text">{{ title }}</span>
      </header>
      <div class="legend-wrap">
        <ul class="legend-labels" [class.horizontal-legend]="horizontal" [style.max-height.px]="lheight - 45">
          <li *ngFor="let entry of legendEntries; trackBy: trackBy" class="legend-label">
            <ngx-charts-legend-entry
              [label]="entry.label"
              [formattedLabel]="entry.formattedLabel"
              [color]="entry.color"
              [isActive]="isActive(entry)"
              (select)="labelClick.emit($event)"
              (activate)="activate($event)"
              (deactivate)="deactivate($event)"
            >
            </ngx-charts-legend-entry>
          </li>
        </ul>
      </div>
    </div>
  `,
  styleUrls: ['./legend.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegendComponent implements OnChanges {
  @Input() data: any[];
  @Input() title: string;
  @Input() colors: ColorHelper;
  @Input() lheight: number;
  private _width: number;
  @Input() set lwidth(value: number) {
    this._width = value;
  }
  get lwidth(): number {
    return this._width;
  }
  @Input() activeEntries;
  @Input() horizontal = false;

  @Output() labelClick: EventEmitter<string> = new EventEmitter();
  @Output() labelActivate: EventEmitter<{ name: string }> = new EventEmitter();
  @Output() labelDeactivate: EventEmitter<{ name: string }> = new EventEmitter();

  @HostBinding('style.position') get position(): string {
    return this.horizontal ? 'relative' : 'absolute';
  }

  @HostBinding('style.right') get right(): string {
    return this.horizontal ? 'unset' : '5px';
  }

  legendEntries: LegendEntry[] = [];

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update(): void {
    this.cd.markForCheck();
    this.legendEntries = this.getLegendEntries();
  }

  getLegendEntries(): LegendEntry[] {
    const items = [];
    for (const obj of this.data) {
      const formattedLabel = formatLabel(obj.label);
      const name = obj.name;
      // const idx = items.findIndex(i => {
      //   return i.label === formattedLabel;
      // });

      // if (idx === -1) {
      let item = {
        name,
        formattedLabel,
        color: this.colors.getColor(obj.name),
      };

      if (!!obj['color']) { // injection des couleurs depuis une props du FD
        item.color = obj['color'];
      }

      items.push(item);

    }

    return items;
  }

  isActive(entry: LegendEntry): boolean {
    return false;
    // if (!this.activeEntries) return false;
    // const item = this.activeEntries.find(d => {
    //   return entry.label === d.name;
    // });
    // return item !== undefined;
  }

  activate(item: { name: string }) {
    this.labelActivate.emit(item);
  }

  deactivate(item: { name: string }) {
    this.labelDeactivate.emit(item);
  }

  trackBy(index: number, item: LegendEntry): string {
    return item.label;
  }
}
